import * as React from "react";

const SvgIcnGenericImage = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 48 48" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M15 15h18a2 2 0 012 2v14a2 2 0 01-2 2H15a2 2 0 01-2-2V17a2 2 0 012-2z" fill="currentColor" />
            <path d="M15 16a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V17a1 1 0 00-1-1H15z" fill="#FFF" />
            <path
                d="M27 23l5 7H16l3.5-4 2.949 3.371L27 23zm-8.5-4a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
                fill="currentColor"
            />
        </g>
    </svg>
);

export default SvgIcnGenericImage;
